import { all, call, select } from 'typed-redux-saga';

import { selectIsTeleMessenger } from '../../../shared/features/config/selectors';
import { goloomSdk } from '../../../shared/features/goloom-sdk';
import { parentFrameCommunicator } from '../../../shared/features/parent-frame-communicator';
import { ChannelHolder } from '../../../shared/helpers/channelHolder';
import { NoiseCancellationTypeChangedEvent, VirtualBackgroundTypeChangedEvent } from '../features/noise-cancellation';
import { OutgoingEvents } from './types';

function* handleNoiseCancellationUpdate({ type }: NoiseCancellationTypeChangedEvent) {
    yield* call([parentFrameCommunicator, parentFrameCommunicator.sendMessage], 'messenger', {
        event: OutgoingEvents.SET_NOISE_CANCELLATION,
        payload: { type },
    });
}

function* handleVirtualBackgroundUpdate({ type }: VirtualBackgroundTypeChangedEvent) {
    yield* call([parentFrameCommunicator, parentFrameCommunicator.sendMessage], 'messenger', {
        event: OutgoingEvents.SET_VIRTUAL_BACKGROUND,
        payload: { type },
    });
}
export function* handleDeviceProcessorsSync() {
    const isTeleMessenger = yield* select(selectIsTeleMessenger);
    if (!isTeleMessenger) {
        return;
    }
    const channelHolder = new ChannelHolder();
    try {
        yield* all([
            channelHolder.takeLatest(goloomSdk.onNoiseCancellationTypeChanged, handleNoiseCancellationUpdate),
            channelHolder.takeLatest(goloomSdk.onVirtualBackgroundTypeChanged, handleVirtualBackgroundUpdate),
        ]);
    } finally {
        channelHolder.close();
    }
}
